// This is a generated file. Any changes made directly in this file will be overwritten.
import * as React from 'react';
import { createSvgIcon } from '@bb-ui/react-library/dist/internal/icons';

export const PartialCredit = createSvgIcon(
  { LeftToRight: <React.Fragment><circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="2" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 10.8247a3.594 3.594 0 01-.5528-.2191c-.3814-.1907-.7323-.461-.9901-.8478C5.2033 9.3773 5 8.825 5 8c0-.825.2034-1.3773.457-1.7578.2579-.3868.6088-.657.9902-.8478A3.5857 3.5857 0 017 5.1754v5.6493z" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12V4S4 4 4 8s4 4 4 4z" /></React.Fragment>, },
  'small'
);
